import { StripePaymentResult } from 'dt-common/generated/graphql-types';
import { EventEmitter } from 'events';
import waitFor from 'dt-common/isomorphic-helpers/waitFor';
import PlayerDispatcher from '~/flux/dispatchers/PlayerDispatcher';
import PaymentsDispatcher from '~/flux/dispatchers/PaymentsDispatcher';
import { registerDispatchHandlers } from '~/Tools';
import Config from '~/constants/Config';
import * as handlers from './handlers';
import messages from './messages';

let playerId: string | null = null;

let card_declined_data: StripePaymentResult | null = null;
let payment_succeeded_data: StripePaymentResult | null = null;
let payment_requires_action_data: StripePaymentResult | null = null;

let stripe: ReturnType<Window['Stripe']> | undefined;

if (Config.USE_STRIPE_PAYMENTS) {
  async function initStripe() {
    await waitFor(() => !!window.Stripe);
    stripe = window.Stripe(process.env.STRIPE_API_KEY!);
  }

  (function (d) {
    const s = d.createElement('script');
    s.src = 'https://js.stripe.com/v3/';
    s.async = true;
    s.onload = () => {
      void initStripe();
    };
    d.body.append(s);
  })(document);
}

const PaymentsStore = Object.assign({}, EventEmitter.prototype, {
  ...messages,

  getAll() {
    return {
      payment_succeeded_data,
      card_declined_data,
      payment_requires_action_data,
      stripe,
    };
  },
});
EventEmitter.call(PaymentsStore);
export default PaymentsStore;

const emit = PaymentsStore.emit.bind(PaymentsStore);

PlayerDispatcher.register(
  registerDispatchHandlers({
    [PlayerDispatcher.PLAYER_LOGGED_IN]: (action: { player: { _id: string } }) => {
      return handlers.onPlayerLoggedIn({ setPlayerId, emit }, action);
    },
  })
);

PaymentsDispatcher.register(
  registerDispatchHandlers({
    [PaymentsDispatcher.CLAIM_KONG_PURCHASES]: () => {
      return handlers.claimKongPurchases({ playerId, emit });
    },
    [PaymentsDispatcher.CREATE_PAYMENT_INTENT]: (action: {
      purchase_selection: { id: string };
      payment_method_id: string;
    }) => {
      return handlers.requestNewPaymentIntent(
        {
          playerId,
          setPaymentSucceededData,
          setCardDeclinedData,
          setPaymentRequiresActionData,
          emit,
        },
        action
      );
    },
    [PaymentsDispatcher.INIT_STEAM_PURCHASE]: (action: {
      purchase_selection: { id: string };
    }) => {
      return handlers.requestInitSteamPurchase({ playerId, emit }, action);
    },
    [PaymentsDispatcher.INIT_YANDEX_PURCHASE]: (action: {
      purchase_selection: { id: string };
    }) => {
      return handlers.initYandexPurchase({ playerId, emit }, action);
    },
  })
);

function setPlayerId(val: string) {
  playerId = val;
}

function setPaymentSucceededData(val: StripePaymentResult) {
  payment_succeeded_data = val;
}

function setCardDeclinedData(val: StripePaymentResult) {
  card_declined_data = val;
}

function setPaymentRequiresActionData(val: StripePaymentResult) {
  payment_requires_action_data = val;
}
